// extracted by mini-css-extract-plugin
module.exports = {"StarsRating":"nt_a pz_b","StarsRating__label":"nt_b pz_nw pz_i","StarsRating__starsWrapper":"nt_c pz_ew pz_i","StarsRating__starsWrapper--gold":"nt_e"};